










import { Component, Vue, Prop } from "vue-property-decorator";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import CdrLeftNav from "../../components/left-nav.vue";
import SizhenPatients from "./sizhen-patients/sizhen-patients.vue";
@Component({
  components: {
    MainHeader,
    CdrLeftNav,
    SizhenPatients
  }
})
export default class CdrPatientList extends Vue {
  private projectName: any = "临床科室数据";
  private projectId: any = "";
  private changeProjectName(name) {
    this.projectName = name;
  }
}
